import Footer from './Footer';

export default Footer;

export * from './BillingFooter';
